// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu--NuchM{z-index:20;min-width:140px}.item--yF0iS{font-size:12px}.item--yF0iS:hover{background-color:#f0f0f4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "menu--NuchM",
	"item": "item--yF0iS"
};
export default ___CSS_LOADER_EXPORT___;
